import axios from '@/lib/axios'
import { buildAdminRequestConfig } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  EmailCampaignId,
  EmailCampaignIndexResponse,
  EmailCampaignPreview,
  EmailCampaignUpdateResponse,
  UpdateEmailCampaignInput,
} from './emailCampaigns.types'

export interface EmailCampaignOrganizationScope {
  organizationId: number
}

/** The index query key's entries; the scoped key builder always sets the organization. */
export type EmailCampaignIndexKeyEntries = EmailCampaignOrganizationScope

/** Calls that act on one campaign schedule. */
export interface EmailCampaignTarget extends EmailCampaignOrganizationScope {
  campaignId: EmailCampaignId
}

/** Query functions read only the key. */
type EmailCampaignQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export async function getEmailCampaigns({
  queryKey: [{ organizationId }],
}: EmailCampaignQueryContext<EmailCampaignIndexKeyEntries>) {
  return axios.get<EmailCampaignIndexResponse>(
    '/email-campaigns',
    buildAdminRequestConfig({ organizationId })
  )
}

export async function updateEmailCampaign({
  organizationId,
  campaignId,
  ...values
}: EmailCampaignTarget & UpdateEmailCampaignInput) {
  return axios.put<EmailCampaignUpdateResponse>(
    `/email-campaigns/${campaignId}`,
    values,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function getEmailCampaignPreview({ organizationId, campaignId }: EmailCampaignTarget) {
  const data = await axios.get<EmailCampaignPreview>(
    `/email-campaigns/${campaignId}/preview`,
    buildAdminRequestConfig({ organizationId })
  )

  return {
    html: data?.html ?? '',
  }
}
